// Static brand content for Geomantic Kalpataru — frontend-only showcase.
// Replace placeholder testimonials, founder info, and contact details later.

export const BRAND = {
  name: "Geomantic Kalpataru",
  tagline: "Ancient Manifestation. Modern Awakening.",
  // Placeholder WhatsApp number — replace with real number when provided
  whatsappNumber: "+910000000000",
  whatsappMessage:
    "Namaste, I would like to learn more about Geomantic Kalpataru manifestation.",
  email: "connect@geomantickalpataru.com",
  city: "New Delhi, India",
  socials: {
    instagram: "https://instagram.com/",
    youtube: "https://youtube.com/",
    facebook: "https://facebook.com/",
  },
};

export const IMG = {
  hero: "https://images.unsplash.com/photo-1534447677768-be436bb09401?q=80&w=2094&auto=format&fit=crop",
  cosmos:
    "https://images.unsplash.com/photo-1502134249126-9f3755a50d78?q=80&w=2070&auto=format&fit=crop",
  sacredGeometry:
    "https://images.unsplash.com/photo-1574686030584-7e449b5c2a38?q=80&w=2070&auto=format&fit=crop",
  founder:
    "https://images.unsplash.com/photo-1507003211169-0a1dd7228f2d?q=80&w=1974&auto=format&fit=crop",
  meditation:
    "https://images.unsplash.com/photo-1515023115689-589c33041d3c?q=80&w=1974&auto=format&fit=crop",
  crystal:
    "https://images.unsplash.com/photo-1602734199653-f7e914a2bb36?q=80&w=2070&auto=format&fit=crop",
  golden:
    "https://images.unsplash.com/photo-1614850523459-c2f4c699c52e?q=80&w=2070&auto=format&fit=crop",
  forest:
    "https://images.unsplash.com/photo-1518531933037-91b2f5f229cc?q=80&w=2127&auto=format&fit=crop",
  ancientBook:
    "https://images.unsplash.com/photo-1456513080510-7bf3a84b82f8?q=80&w=1973&auto=format&fit=crop",
  temple:
    "https://images.unsplash.com/photo-1605379399642-870262d3d051?q=80&w=2070&auto=format&fit=crop",
  candle:
    "https://images.unsplash.com/photo-1602192509154-0b900ee1f851?q=80&w=2070&auto=format&fit=crop",
  yoga: "https://images.unsplash.com/photo-1545389336-cf090694435e?q=80&w=2070&auto=format&fit=crop",
  mandala:
    "https://images.unsplash.com/photo-1564507592333-c60657eea523?q=80&w=2070&auto=format&fit=crop",
  galaxy:
    "https://images.unsplash.com/photo-1462331940025-496dfbfc7564?q=80&w=2070&auto=format&fit=crop",
  fire: "https://images.unsplash.com/photo-1492112007959-c35ae067c37b?q=80&w=2069&auto=format&fit=crop",
  avatar1:
    "https://images.unsplash.com/photo-1534528741775-53994a69daeb?q=80&w=400&auto=format&fit=crop",
  avatar2:
    "https://images.unsplash.com/photo-1506794778202-cad84cf45f1d?q=80&w=400&auto=format&fit=crop",
  avatar3:
    "https://images.unsplash.com/photo-1544005313-94ddf0286df2?q=80&w=400&auto=format&fit=crop",
  avatar4:
    "https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?q=80&w=400&auto=format&fit=crop",
};

export const HOW_IT_WORKS = [
  {
    n: "01",
    title: "Define Your Intention",
    body:
      "We begin by listening — to your desire, your blockages, and the unspoken longings of your soul. A sacred intention is the seed of every manifestation.",
  },
  {
    n: "02",
    title: "Sacred Geomantic Analysis",
    body:
      "Your name, birth coordinates and energetic signature are mapped to ancient geomantic figures, revealing the symbols that command your unique reality.",
  },
  {
    n: "03",
    title: "Symbolic Activation",
    body:
      "A bespoke Kalpataru yantra is encoded for you — a living geometry charged through Brahma Satya rituals, mantra and the founder's spiritual siddhi.",
  },
  {
    n: "04",
    title: "Energy Alignment",
    body:
      "Reiki Riddhi and Spiritual Healing Siddhi sessions dissolve karmic friction in the chakras, your home and your field — clearing the path for manifestation.",
  },
  {
    n: "05",
    title: "Manifestation Journey",
    body:
      "You receive a 90-day guided practice — daily invocations, energetic check-ins and a private channel with your guide — until the desire takes form in matter.",
  },
];

export const BENEFITS = [
  {
    title: "Relationships",
    body: "Heal lineage wounds, attract aligned partnership, restore harmony at home.",
    icon: "Heart",
  },
  {
    title: "Prosperity",
    body: "Open Lakshmi gates — unblock wealth channels and welcome abundance.",
    icon: "Sparkles",
  },
  {
    title: "Career Growth",
    body: "Magnetize the right opportunities, mentors and decisive recognition.",
    icon: "TrendingUp",
  },
  {
    title: "Health Alignment",
    body: "Subtle-body healing that supports physical vitality and clarity.",
    icon: "Sun",
  },
  {
    title: "Emotional Healing",
    body: "Release stored grief, anxiety and the inherited patterns of the past.",
    icon: "Droplet",
  },
  {
    title: "Spiritual Development",
    body: "Awaken kundalini awareness, deepen meditation and meet the inner guru.",
    icon: "Eye",
  },
];

export const TESTIMONIALS = [
  {
    name: "A. Sharma",
    role: "Entrepreneur, Bengaluru",
    avatar: "avatar1",
    quote:
      "Within ninety days my business doubled and a decade-old family conflict resolved on its own. The Kalpataru process is unlike anything I have ever experienced.",
  },
  {
    name: "R. Iyer",
    role: "Doctor, Mumbai",
    avatar: "avatar2",
    quote:
      "I came searching for healing for my mother. I received that — and a complete reordering of my own life. The work is gentle, exacting, deeply real.",
  },
  {
    name: "S. Kapoor",
    role: "Architect, Delhi",
    avatar: "avatar3",
    quote:
      "The yantra felt alive the moment it arrived. Six months later my dream project landed in my lap. I am still in awe of what was set in motion.",
  },
  {
    name: "M. Banerjee",
    role: "Author, Kolkata",
    avatar: "avatar4",
    quote:
      "The Brahma Satya healing dissolved a grief I had carried since childhood. I write now from a place I did not know existed inside me.",
  },
];

export const ARTICLES = [
  {
    slug: "what-is-geomancy",
    title: "What is Geomancy — and why ancients trusted it",
    excerpt:
      "From the deserts of Arabia to the Vedic plains, geomancy mapped the unseen architecture of fate. Here is what the modern seeker needs to know.",
    image: "ancientBook",
    tag: "Ancient Wisdom",
    minutes: 7,
  },
  {
    slug: "kalpataru-tree",
    title: "The Kalpataru tree: a living blueprint for desire",
    excerpt:
      "The wish-fulfilling tree is not myth alone — it is a precise instruction set for how intention crystallises into form.",
    image: "forest",
    tag: "Manifestation Science",
    minutes: 6,
  },
  {
    slug: "siddhis-modern",
    title: "Spiritual siddhis for the modern householder",
    excerpt:
      "You do not have to leave the world to wield subtle power. A practical guide to integrating siddhi into ordinary life.",
    image: "candle",
    tag: "Spiritual Growth",
    minutes: 9,
  },
  {
    slug: "yantra-explained",
    title: "Why a personalised yantra outperforms a generic one",
    excerpt:
      "The geometry must match the soul-signature. Anything less is decoration.",
    image: "mandala",
    tag: "Sacred Geometry",
    minutes: 5,
  },
  {
    slug: "brahma-satya",
    title: "Brahma Satya: the system behind the work",
    excerpt:
      "An overview of the lineage, the energy stream and the ethical commitments that hold this work.",
    image: "temple",
    tag: "System",
    minutes: 8,
  },
  {
    slug: "money-blocks",
    title: "Seven money blocks geomancy can dissolve",
    excerpt:
      "Most wealth ceilings are not strategic — they are subtle. Here is how to spot and release them.",
    image: "golden",
    tag: "Prosperity",
    minutes: 6,
  },
];

export const FAQS = [
  {
    q: "Is Geomantic Kalpataru a religion?",
    a: "No. It is a practical manifestation system rooted in ancient geomancy and the Brahma Satya stream. It honours all faiths and asks for none.",
  },
  {
    q: "How long does the process take?",
    a: "The core journey runs ninety days. Many seekers begin to see shifts within the first two weeks; deeper transformations unfold over six to nine months.",
  },
  {
    q: "Do I need to travel?",
    a: "No. The entire process is conducted remotely — consultation, geomantic mapping, yantra activation and healing sessions are all delivered online.",
  },
  {
    q: "What if I am sceptical?",
    a: "Scepticism is welcome. The work asks only that you remain honest and observe. Most seekers arrive sceptical and leave with their own evidence.",
  },
  {
    q: "Is there a guarantee?",
    a: "We do not guarantee outcomes — no honest spiritual practice can. We guarantee the integrity of the process and our full presence with you.",
  },
  {
    q: "How do I begin?",
    a: "Book a consultation through WhatsApp. The founder personally responds to every initial enquiry.",
  },
];

export const PRODUCTS = [
  {
    name: "Personal Kalpataru Yantra",
    body: "A consecrated geometry encoded to your soul-signature — the cornerstone of the manifestation process.",
    image: "mandala",
    price: "By consultation",
  },
  {
    name: "Brahma Satya Healing Series",
    body: "A six-session subtle-body alignment programme using Reiki Riddhi and Spiritual Healing Siddhi.",
    image: "candle",
    price: "By consultation",
  },
  {
    name: "Home Geomantic Audit",
    body: "Remote analysis of your dwelling's energetic blueprint with corrective placements.",
    image: "temple",
    price: "By consultation",
  },
  {
    name: "Lineage Karmic Clearing",
    body: "Deep ritual to release ancestral patterns blocking abundance, partnership or health.",
    image: "fire",
    price: "By consultation",
  },
];

export const GALLERY = [
  "sacredGeometry",
  "meditation",
  "crystal",
  "golden",
  "temple",
  "mandala",
  "candle",
  "yoga",
  "galaxy",
  "fire",
  "forest",
  "cosmos",
];

export const BLOG_POSTS = ARTICLES.map((a) => ({
  ...a,
  date: "Feb 14, 2026",
  author: "The Geomantic Kalpataru Studio",
}));

export const PODCASTS = [
  {
    id: "ep-01",
    number: "01",
    title: "The Architecture of Manifestation",
    host: "The Founder",
    guest: "In conversation with seekers",
    duration: "42 min",
    date: "Feb 2026",
    image: "galaxy",
    description:
      "What does it actually mean to manifest? A first-principles conversation on intention, energetic architecture and why most manifestation methods miss the mark.",
    listenUrl: "https://open.spotify.com/",
    youtubeUrl: "https://www.youtube.com/",
    tag: "Foundations",
  },
  {
    id: "ep-02",
    number: "02",
    title: "Geomancy: The Forgotten Science",
    host: "The Founder",
    guest: "Solo episode",
    duration: "38 min",
    date: "Feb 2026",
    image: "ancientBook",
    description:
      "A deep dive into the sixteen geomantic figures, their lineage across cultures, and why they remain the most precise instrument for reading reality.",
    listenUrl: "https://open.spotify.com/",
    youtubeUrl: "https://www.youtube.com/",
    tag: "Ancient Wisdom",
  },
  {
    id: "ep-03",
    number: "03",
    title: "Brahma Satya: Holding the Lineage",
    host: "The Founder",
    guest: "Lineage holders panel",
    duration: "55 min",
    date: "Jan 2026",
    image: "temple",
    description:
      "A roundtable on what it means to carry a living spiritual stream into the modern world — and the ethics that protect it.",
    listenUrl: "https://open.spotify.com/",
    youtubeUrl: "https://www.youtube.com/",
    tag: "System",
  },
  {
    id: "ep-04",
    number: "04",
    title: "Money, Karma and the Lakshmi Gate",
    host: "The Founder",
    guest: "With a wealth-channel seeker",
    duration: "47 min",
    date: "Jan 2026",
    image: "golden",
    description:
      "Why so many capable people remain wealth-blocked, and the subtle work that finally moves the needle. A practical, grounded episode.",
    listenUrl: "https://open.spotify.com/",
    youtubeUrl: "https://www.youtube.com/",
    tag: "Prosperity",
  },
  {
    id: "ep-05",
    number: "05",
    title: "The Kalpataru Tree: Myth as Blueprint",
    host: "The Founder",
    guest: "Solo episode",
    duration: "33 min",
    date: "Dec 2025",
    image: "forest",
    description:
      "Decoding the wish-fulfilling tree as an instruction set — not a fable. The four roots, the central trunk and the fruits.",
    listenUrl: "https://open.spotify.com/",
    youtubeUrl: "https://www.youtube.com/",
    tag: "Manifestation Science",
  },
  {
    id: "ep-06",
    number: "06",
    title: "Healing What Therapy Cannot Reach",
    host: "The Founder",
    guest: "With a healing siddhi practitioner",
    duration: "51 min",
    date: "Dec 2025",
    image: "candle",
    description:
      "On lineage trauma, karmic residue and the subtle-body work that resolves what conventional methods leave behind.",
    listenUrl: "https://open.spotify.com/",
    youtubeUrl: "https://www.youtube.com/",
    tag: "Spiritual Healing",
  },
];
